import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Navbar";

export const Services = () => {
  return (
    <section id="services" data-testid="services" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand mb-4">02 — Our Services</p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="font-display font-extrabold text-navy tracking-tight text-4xl md:text-5xl max-w-xl leading-[1.05]">
              Financing solutions for every stage of growth.
            </h2>
            <p className="text-ink/55 max-w-sm text-base md:text-lg">
              From working capital to machinery finance — structured facilities up to ₹5 Crore.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <button
                data-testid={`service-card-${i}`}
                onClick={() => scrollTo("contact")}
                className="group text-left w-full h-full bg-surface rounded-2xl p-8 border border-black/5 hover:bg-navy transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="grid place-items-center w-12 h-12 rounded-xl bg-white text-brand group-hover:bg-brand group-hover:text-white transition-colors">
                    <s.icon className="w-5 h-5" />
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-ink/30 group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl text-navy group-hover:text-white transition-colors">{s.title}</h3>
                <p className="mt-2 text-sm text-ink/55 group-hover:text-white/70 leading-relaxed transition-colors">{s.desc}</p>
                <span className="mt-5 inline-block text-sm font-semibold text-brand group-hover:text-emerald transition-colors">Learn More →</span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
